import { Injectable } from '@angular/core';
import firebase from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth'; // angularfire2/auth";
import { v4 as uuid } from 'uuid';

@Injectable()
export class UserService {
  private _user;

  // the basic user, no job datas
  get user() {
    return this._user;
  }

  set user(user) {
    this._user = user;
  }

  constructor(public auth: AngularFireAuth) {
    auth.user.subscribe(user => {
      // if no user create uid visitor and store it in LS
      if (user) {
        this.user = user;
      } else {
        this.addVisitor();
      }
      // const log: Log = {template: 'Connection', prefix: this.name ? this.name : 'Visitor', label: `has connected to the game server`};
      // this.roomService.updateRoom(`${this.roomId}/logs`, this.logs, log); */
    });
  }

  userRestrictions(matchingRoomUser?) {
    return this.user
      ? {
          /// room-selection
          createRoom: !this.user.displayName.startsWith('visitor'),
          joinGameAsPlayer: !this.user.displayName.startsWith('visitor'),
          joinGameAsSpectator: true,
          // room-creation
          editForm:
            !this.user.displayName.startsWith('visitor') &&
            matchingRoomUser &&
            matchingRoomUser.roles.includes('host')
              ? true
              : false,
          // game
          playGame:
            !this.user.displayName.startsWith('visitor') &&
            matchingRoomUser &&
            matchingRoomUser.roles.includes('player')
              ? true
              : false
        }
      : null;
  }

  addVisitor() {
    let localstorageUser = localStorage.getItem('localstorageUser');
    if (!localstorageUser) {
      const visitorUser = {
        uid: uuid(),
        displayName: 'visitor' + Math.floor(Math.random() * Math.floor(9999))
        // roles: ['spectator'],
        // activePlayer: false,
      };
      localStorage.setItem('localstorageUser', JSON.stringify(visitorUser));
      this.user = visitorUser;
    } else {
      this.user = JSON.parse(localstorageUser);
    }
    /*
      this.room.users.push(visitorUser);
      this.roomService.updateRoom(`${this.roomId}/room`, this.room);
    */
  }

   // Auth logic to run auth providers
   AuthLogin(provider) {
    return this.auth.signInWithPopup(provider)
    .then((result) => {
        console.log('You have been successfully logged in!')
    }).catch((error) => {
        console.log(error)
    })
  }

  login(e) {
    e.preventDefault();
    this.AuthLogin(new firebase.auth.GoogleAuthProvider());
    /* e.preventDefault();
    this.auth
      .auth()
      .signInWithPopup(new this.auth.auth().GoogleAuthProvider())
      .catch(err => console.log('err', err)); */
  }

  logout() {
    this.auth.signOut();
  }

  static isVisitor(user): boolean {
    return user.displayName.startsWith('visitor');
  }
}
